import { createFileRoute } from '@tanstack/react-router';

import { InvoiceV2DetailContent } from '~/modules/invoice/v2';

export const Route = createFileRoute(
  '/(main)/invoices/v2/incoming/$invoiceId/',
)({
  component: InvoiceV2DetailContent,
});
